//
// [アドイン] 念の為もう一回聞くからな？モーダル
//
// doubleConfirmModal.js
//

import React from "react";
import '../styles/doubleConfirmModal.css';

export default function DoubleConfirmModal({
  message = "よろしいですか？",
  onConfirm = () => {},
  onCancel = null,
  confirmText = "OK",
  cancelText = "キャンセル",
  showCancel = false,
}) {
  return (
    <div className="modal-overlay">
      <div className="modal-window">
        <p>{message}</p>
        <div className="modal-buttons">
          {showCancel && (
            <button onClick={onCancel} style={{ background: "#f88" }}>{cancelText}</button>
          )}
          <button onClick={onConfirm} style={{ background: "#8af" }}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
}
